export function AppCrashFallback() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", gap: "16px", fontFamily: "sans-serif" }}>
      <h2>Something went wrong</h2>
      <p style={{ color: "#666" }}>The error has been reported. Try reloading.</p>
      <button onClick={() => window.location.reload()} style={{ padding: "8px 20px", cursor: "pointer" }}>
        Reload
      </button>
    </div>
  );
}
